export type Bonus = {
  id: string
  title: string
  value: string
  tagline: string
  paragraphs: string[]
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'BJJ Technique Breakdown Library',
    value: '12',
    tagline:
      'Step-by-step technical explanations for essential Brazilian Jiu-Jitsu skills',
    paragraphs: [
      'A practical technique library that breaks down essential BJJ movements into clear, teachable steps. Includes positioning details, grips, body alignment, weight distribution, movement sequence, control points, finishing mechanics, safety considerations and common technical errors.',
      'This resource helps instructors explain techniques more clearly, demonstrate movements with greater precision and make complex skills easier for students to understand and repeat. Covers fundamental movements, escapes, guard techniques, passes, transitions, positional controls, takedowns and submissions.',
    ],
    benefit:
      'Open it, follow the structure, and your demonstrations become a clear learning process.',
  },
  {
    id: '02',
    title: '36-Week BJJ Curriculum Map',
    value: '12',
    tagline:
      'A complete progressive teaching plan for organizing an entire training year',
    paragraphs: [
      'A structured 36-week curriculum map that shows instructors what to teach, when to teach it and how to connect each technical area throughout the training year. The program organizes movement, safety, guard, escapes, passing, positional control, transitions, takedowns, submissions, review sessions, assessments and controlled sparring into a logical progression.',
      'Helps instructors avoid random lesson planning, maintain continuity between classes and ensure students develop the necessary foundations before advancing to more complex skills. Ideal for academies, beginner programs, youth-to-adult transitions, seasonal courses and instructors who want a clear long-term teaching structure.',
    ],
    benefit: 'One system. The entire year. Nothing to rebuild from scratch.',
  },
  {
    id: '03',
    title: 'Student Progress & Belt Assessment System',
    value: '10',
    tagline:
      'A practical framework for tracking skills, evaluating progress and supporting belt decisions',
    paragraphs: [
      'A complete assessment system designed to help instructors monitor technical development, attendance, consistency, behavior, safety awareness, positional understanding, practical application and overall student progress. Includes evaluation criteria, skill checklists, progress records, observation forms, assessment categories, promotion considerations and tools for identifying areas that need improvement.',
      'Helps instructors make more consistent decisions, provide clearer feedback, set realistic development goals and create a more transparent path toward advancement. Can be adapted for beginner and developing students, children, teenagers, adults, private students and academy-wide evaluation systems.',
    ],
    benefit: 'Open it, pick the session and your class starts strong.',
  },
  {
    id: '04',
    title: 'Private Lessons, Group Classes & Academy Adaptation System',
    value: '10',
    tagline:
      'Adapt the same BJJ content to different formats, group sizes and teaching environments',
    paragraphs: [
      'Shows you exactly how to adapt BJJ lessons for private sessions, small groups, clinics, youth programs and academy training. Explains how to adjust class structure, practice time, feedback delivery, student rotation and activity difficulty based on the number of practitioners and teaching environment.',
      'Learn how to keep all students engaged, reduce waiting time and organize station work, partner activities and group challenges more effectively. Includes guidance for adapting lessons when students have different experience levels, physical abilities or learning speeds.',
    ],
    benefit: 'One system. Every format. Nothing to rebuild from scratch.',
  },
  {
    id: '05',
    title: '30 Emergency & Limited Space BJJ Classes',
    value: '10',
    tagline:
      'Ready-to-use sessions for unexpected situations, reduced mat space and restricted training environments',
    paragraphs: [
      '30 complete lesson options for the days when the original plan cannot be used due to unavailable facilities, limited mat space, reduced equipment or unexpected group sizes. Topics include individual movement, positioning, solo drills, technical visualization, tactical understanding, position analysis, competition rules, mental routines, technical review and decision-making.',
      'Each session is designed to help you keep teaching without wasting the scheduled class or improvising at the last minute. A reliable backup system that protects class quality, maintains student engagement and keeps the learning process moving forward even when conditions change unexpectedly.',
    ],
    benefit: 'Open it, pick the session and your class starts strong.',
  },
]

export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — BJJ Technique Breakdown Library', value: '$12' },
  { label: 'Bonus 2 — 36-Week Curriculum Map', value: '$12' },
  { label: 'Bonus 3 — Student Progress & Belt Assessment System', value: '$10' },
  { label: 'Bonus 4 — Private, Group & Academy Adaptation System', value: '$10' },
  { label: 'Bonus 5 — 30 Emergency & Limited Space Classes', value: '$10' },
]
